import { createAction } from '@reduxjs/toolkit';
import { API, CustomerContract, ErrorObject, UUID } from 'types';

export const fetchCustomerContracts = createAction('CUSTOMER_CONTRACTS/FETCH_CUSTOMER_CONTRACTS');
export const fetchCustomerContractsRequest = createAction(
  'CUSTOMER_CONTRACTS/FETCH_CUSTOMER_CONTRACTS_REQUEST'
);
export const fetchCustomerContractsFailure = createAction<ErrorObject>(
  'CUSTOMER_CONTRACTS/FETCH_CUSTOMER_CONTRACTS_FAILURE'
);
export const fetchCustomerContractsSuccess = createAction<API.WrappedAPIResponse<CustomerContract>>(
  'CUSTOMER_CONTRACTS/FETCH_CUSTOMER_CONTRACTS_SUCCESS'
);
export const fetchCustomerContractsFulfill = createAction(
  'CUSTOMER_CONTRACTS/FETCH_CUSTOMER_CONTRACTS_FULFILL'
);

type UpsetCustomerContractPayload = {
  contract: Partial<CustomerContract> & { file?: File };
  action?: 'add' | 'delete';
};

export const upsertCustomerContract = createAction<UpsetCustomerContractPayload>(
  'CUSTOMER_CONTRACTS/UPSERT_CUSTOMER_CONTRACT'
);
export const upsertCustomerContractRequest = createAction(
  'CUSTOMER_CONTRACTS/UPSERT_CUSTOMER_CONTRACT_REQUEST'
);
export const upsertCustomerContractFailure = createAction<ErrorObject>(
  'CUSTOMER_CONTRACTS/UPSERT_CUSTOMER_CONTRACT_FAILURE'
);
export const upsertCustomerContractsuccess = createAction<CustomerContract>(
  'CUSTOMER_CONTRACTS/UPSERT_CUSTOMER_CONTRACT_SUCCESS'
);

export const deleteCustomerContract = createAction<{ uuid: UUID; redirect?: boolean }>(
  'CUSTOMER_CONTRACTS/DELETE_CUSTOMER_CONTRACT'
);
export const deleteCustomerContractRequest = createAction(
  'CUSTOMER_CONTRACTS/DELETE_CUSTOMER_CONTRACT_REQUEST'
);
export const deleteCustomerContractFailure = createAction<ErrorObject>(
  'CUSTOMER_CONTRACTS/DELETE_CUSTOMER_CONTRACT_FAILURE'
);
export const deleteCustomerContractsuccess = createAction<{ uuid: UUID }>(
  'CUSTOMER_CONTRACTS/DELETE_CUSTOMER_CONTRACT_SUCCESS'
);

export const fetchSingleCustomerContract = createAction<{ uuid: UUID }>(
  'CUSTOMER_CONTRACTS/FETCH_SINGLE_CUSTOMER_CONTRACT'
);
export const fetchSingleCustomerContractRequest = createAction(
  'CUSTOMER_CONTRACTS/FETCH_SINGLE_CUSTOMER_CONTRACT_REQUEST'
);
export const fetchSingleCustomerContractFailure = createAction<ErrorObject>(
  'CUSTOMER_CONTRACTS/FETCH_SINGLE_CUSTOMER_CONTRACT_FAILURE'
);
export const fetchSingleCustomerContractsuccess = createAction<CustomerContract>(
  'CUSTOMER_CONTRACTS/FETCH_SINGLE_CUSTOMER_CONTRACT_SUCCESS'
);

export const downloadContract = createAction<{ contractId: string }>(
  'CUSTOMER_CONTRACTS/DOWNLOAD_CONTRACT'
);
